import React from 'react';
import { FundsFilters } from '../../../../app/models/Fund';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';

type Props = {
    filter: FundsFilters;
    setFilter: (filter: FundsFilters) => void;
    onSearch: () => void;
};

const FundsRequestFilter = ({ filter, setFilter, onSearch }: Props) => {

    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    const handlerSelectFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };


    return (
        
            <div className="row">
                <div className="row">
                    <div className="col-md-auto">
                        <div>
                            <label className="font-size-10 mb-1">Conductor</label>
                            <input
                                title="Conductor"
                                type="text"
                                id="carrier"
                                name="carrier"
                                className="form-control form-control-sm"
                                value={filter.carrier ?? ''}
                                onChange={(e) => handlerInputFilter(e)}
                            />
                        </div>
                    </div>
                    <div className="col-md-auto">
                        <div>
                            <label className="font-size-10 mb-1">Fecha</label>
                            <input
                                title="Fecha de emisión"
                                type="date"
                                id="date"
                                name="date"
                                className="form-control form-control-sm"
                                value={filter.date}
                                onChange={(e) => handlerInputFilter(e)}
                            />
                        </div>
                    </div>
                    <div className="col-md-auto">
                        <div>
                            <label className="font-size-10 mb-1">Motivo</label>
                            <input
                                title="Motivo"
                                type="text"
                                id="transfer_reason"
                                name="transfer_reason"
                                className="form-control form-control-sm"
                                value={filter.transfer_reason ?? ''}
                                onChange={(e) => handlerInputFilter(e)}
                            />
                        </div>
                    </div>
                    <div className="col-md-auto">
                        <div>
                            <label className="font-size-10 mb-1">Solicitado por</label>
                            <input
                                title="created_user"
                                type="text"
                                id="created_user"
                                name="created_user"
                                className="form-control form-control-sm"
                                value={filter.created_user ?? ''}
                                onChange={(e) => handlerInputFilter(e)}
                            />
                        </div>
                    </div>
                    <div className="col-md-auto">
                        <div className="mb-3">
                            <label className="font-size-10 mb-1" htmlFor="quote_status">
                                Estado
                            </label>
                            <select
                                // comentar id para evitar error de estilo en el filtro.
                                // id="status"
                                name="status"
                                className="form-control form-control-sm"
                                value={filter.status ?? ''}
                                onChange={(e) => handlerSelectFilter(e)}
                            >
                                <option value="">TODOS</option>
                                <option value="DRAFT">Borrador</option>
                                <option value="REQUEST">Solicitada</option>
                                <option value="CONFIRM">Confirmada</option>
                                <option value="REJECT">Rechazada</option>
                                <option value="CANCEL">Anulada</option>
                            </select>
                        </div>
                    </div>  
                    <div className='col-md-auto'>
                        <div style={{marginTop: '22px'}}>
                            <ButtonSearchFilter callbackSearch={onSearch}/>
                        </div>
                    </div>
                </div>
            </div>
        
    );
};

export default FundsRequestFilter;
